import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl';
import withNavigate from '../../components/common/withNavigate'
import API from '../../utils/API'

const API_URL = process.env.REACT_APP_API_URL;
function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

class AlertsPlusTemplateForm extends React.Component {
  state = {
    name: '',
    iconURL: `${API_URL}/aplus/icons/default.png`,
    iconFile: null,
    imageURL: `${API_URL}/aplus/images/default.png`,
    imageFile: null,
    duration: 99999,
    preset: 9999,
    sound: false,
    error: '',
  };

  componentDidMount() {
    console.log(this.props);
    if(this.props.cloudSide){
      if(this.props.alertPlustemplate && this.props.alertPlustemplate !== ''){
        this.setTemplate(this.props.alertPlustemplate);
      }
    }else{
      const search = new URLSearchParams(window.location.search)
      let id = search.get('id');
  
      if(id){
        API.getTemplate(id)
        .then(res => {
            this.setState({
              name: res.data.name,
              duration: res.data.duration,
              preset: res.data.preset,
              sound: res.data.sound,
              iconURL: res.data.icon ? res.data.icon : this.state.iconURL,
              imageURL: res.data.image ? res.data.image : this.state.imageURL,
            }, ()=>{
            })})
      }
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if(this.props.alertPlustemplate != undefined && prevProps.alertPlustemplate !== this.props.alertPlustemplate){
      if(this.props.alertPlustemplate !== ""){
        console.log("******AlertsPlusTemplateForm componentDidUpdate****edit*********");
        this.setTemplate(this.props.alertPlustemplate);
      }else{
        console.log("******AlertsPlusTemplateForm componentDidUpdate****create*********");
        this.setState({
          name: '',
          iconURL: `${API_URL}/aplus/icons/default.png`,
          iconFile: null,
          imageURL: `${API_URL}/aplus/images/default.png`,
          imageFile: null,
          duration: 99999,
          preset: 9999,
          sound: false,
        })
      }
    }
  }

  setTemplate = (template) => {
    this.setState({
      name: template.name,
      duration: template.duration,
      preset: template.preset,
      sound: template.sound,
      iconURL: template.icon ? template.icon : this.state.iconURL,
      imageURL: template.image ? template.image : this.state.imageURL,
    })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    //const search = new URLSearchParams(window.location.search)
    let token = ""; //= search.get('token');
    let id = null; //= search.get('id');
    if(this.props.cloudSide){
      if(this.props.alertPlustemplate && this.props.alertPlustemplate !== ''){
        id = this.props.alertPlustemplate.id;
      }
    }else{
      const search = new URLSearchParams(window.location.search)
      token = search.get('token');
      id = search.get('id');
    }
    
    if(!this.state.name){
      this.setState({error: `Missing name.`})
      return;
    }
    if(id) {
      API.updateTemplate(id, token, this.state.name, this.state.duration, this.state.preset, 
        this.state.sound, this.state.iconFile, this.state.imageFile)
      .then(res => {
        const { data } = res
        if (data.error) return this.setState({ error: data.error })
        this.props.onSuccess(this.props.method);
      }).catch(err => {
        console.error(err)
        this.setState({ error: err.message })
      })
    } else {
      API.uploadTemplate(token, this.state.name, this.state.duration, this.state.preset, 
        this.state.sound, this.state.iconFile, this.state.imageFile)
      .then(res => {
        const { data } = res
        if (data.error) return this.setState({ error: data.error })
        this.props.onSuccess(this.props.method);
      }).catch(err => {
        console.error(err)
        this.setState({ error: err.response.data })
      })
    }
  }

  onNameChange = (event) => {
    this.setState({name: event.target.value})
  }

  onIconChange = (event) => {
    console.log(event.target.files[0])
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0])
    reader.onloadend = (e) => {
      this.setState({iconURL: reader.result, iconFile: event.target.files[0]})
    }
  }

  onImageChange = (event) => {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0])
    reader.onloadend = (e) => {
      this.setState({imageURL: reader.result, imageFile: event.target.files[0]})
    }
  }

  onSoundChange = (event) => {
    this.setState({sound: !this.state.sound})
  }

  onSelectChange = (event) => {
    this.setState({preset: event.target.value})
  }

  onDurationChange = (event) => {
    this.setState({duration: event.target.value})
  }

  onPresetChange = (event) => {
    this.setState({preset: event.target.value})
  }

  render () {
    return (
        <div className='row'>
            <form>
                <div className="row">
                  <div className="col-8">
                    <div className="row">
                      <div className="input-group my-3 px-2">
                        <div className="input-group-prepend">
                          <span className="input-group-text" style={{borderRadius: '.375rem 0 0 .375rem'}}><FormattedMessage id="ALERT_NAME" /></span>
                        </div>
                        <input type="text" className="form-control" value={this.state.name} onChange={this.onNameChange}/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="input-group my-3 px-2">
                      <span className="input-group-text"><FormattedMessage id="ICON" /></span>
                        <label className="form-control" tabIndex="0">
                          {this.state.iconFile ? 
                            `${this.state.iconFile.name} ${formatBytes(this.state.iconFile.size)}`  
                            : <FormattedMessage id="UPLOAD_AN_ICON" />}
                          <input type="file" className="invisible" id="userIconFile" onChange={this.onIconChange}/>
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div>
                        <FormattedMessage id="ALERT_PLUS_SET_ICONS_WARNING" />
                      </div>
                      <div className="d-flex flex-row justify-content-left p-2">
                        <div className="d-flex justify-content-center" style={{'backgroundColor': 'white'}}>
                          <img className="p-2" src={this.state.iconURL} style={{maxWidth: '120px'}} alt=""/>
                        </div>
                        <div className="d-flex justify-content-center" style={{'backgroundColor': 'black'}}>
                          <img className="p-2" src={this.state.iconURL} style={{maxWidth: '120px'}} alt=""/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="input-group my-3 px-2">
                      <span className="input-group-text"><FormattedMessage id="IMAGE" /></span>
                        <label className="form-control" tabIndex="0">
                          {this.state.imageFile ? 
                            `${this.state.imageFile.name} ${formatBytes(this.state.imageFile.size)}`  
                            : <FormattedMessage id="UPLOAD_AN_ICON" />}
                          <input type="file" className="invisible" id="userImageFile" onChange={this.onImageChange}/>
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div>
                        <FormattedMessage id="ALERT_PLUS_IMAGE_WARNING" />
                      </div>
                      <div className="d-flex flex-row justify-content-left p-2">
                        <div className="d-flex mx-2 justify-content-center" style={{width: '480px', height: '270px', 'backgroundColor': 'black', position: 'relative'}}>
                          <img src={this.state.imageURL} style={{maxWidth: '480px'}} alt=""/>
                          <div style={{position: 'absolute', fontSize: '32px', left: '8px', color: 'lightsteelblue'}}>16:9</div>
                        </div>
                        <div className="d-flex justify-content-center" style={{width: '360px', height: '270px', 'backgroundColor': 'black', position: 'relative'}}>
                          <img src={this.state.imageURL} style={{maxWidth: '480px'}} alt=""/>
                          <div style={{position: 'absolute', fontSize: '32px', left: '8px', color: 'lightsteelblue'}}>4:3</div>
                        </div>
                      </div>
                      {/* <div className="d-flex flex-row justify-content-left p-2">
                        <div className="d-flex justify-content-center" style={{width: '480px', height: '270px', 'backgroundColor': 'black'}}>
                          <img src={this.state.imageURL} style={{maxWidth: '480px'}} alt=""/>
                        </div>
                      </div> */}
                    </div>
                    <div className="row">
                      <div className="col-3 my-3 px-2">
                        <div><span><FormattedMessage id="DURATION" /></span>
                            <select onChange={this.onDurationChange} value={this.state.duration} className="form-select">
                                <option value={99999}><FormattedMessage id="DURATION_INDEFINITE" /></option>
                                <option value={1}><FormattedMessage id="DURATION_1_MINUTE" /></option>
                                <option value={10}><FormattedMessage id="DURATION_MINUTES" values={{number: <span>10</span>,}}/></option>
                                <option value={30}><FormattedMessage id="DURATION_MINUTES" values={{number: <span>30</span>,}}/></option>
                                <option value={60}><FormattedMessage id="DURATION_1_HOUR" /></option>
                                <option value={120}><FormattedMessage id="DURATION_HOURS" values={{number: <span>2</span>,}}/></option>
                                <option value={240}><FormattedMessage id="DURATION_HOURS" values={{number: <span>4</span>,}}/></option>
                                <option value={480}><FormattedMessage id="DURATION_HOURS" values={{number: <span>8</span>,}}/></option>
                                <option value={1440}><FormattedMessage id="DURATION_HOURS" values={{number: <span>24</span>,}}/></option>
                                <option value={4320}><FormattedMessage id="DURATION_HOURS" values={{number: <span>72</span>,}}/></option>
                            </select>
                        </div>
                      </div>
                      <div className="col-6 my-3 px-2">
                        <div><span><FormattedMessage id="ALERT_PLUS_MAKE_PRESET" /></span>
                            <select onChange={this.onSelectChange} value={this.state.preset} className="form-select">
                                <option value={9999}><FormattedMessage id="NO" /></option>
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                                <option value={3}>3</option>
                                <option value={4}>4</option>
                                <option value={5}>5</option>
                            </select>
                        </div>
                      </div>
                      <div className="col-3 my-3 py-4 pl-2">
                        <div className="form-check">
                            <input onChange={this.onSoundChange} checked={this.state.sound} className="form-check-input" type="checkbox" id="alertSound" />
                            <label className="form-check-label" htmlFor="alertSound">
                              <FormattedMessage id="ALERT_SOUND" />
                            </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                <div className="modal-footer">
                  <button type="button" className="btn save-btn" onClick={this.handleSubmit}>{this.props.method === "POST" ? <FormattedMessage id="CREATE_ALERT" /> : <FormattedMessage id="UPDATE_ALERT" />}</button>
                </div>
                  {/*<div className="col-8 pe-0">
                    <button type="button" className="btn btn-primary w-100 my-4" onClick={this.handleSubmit}>{this.props.method === "POST" ? <FormattedMessage id="CREATE_ALERT" /> : <FormattedMessage id="UPDATE_ALERT" />}</button>
                    </div>*/}
                </div>
                <div className="row">
                  <div className="col-8 pe-0 text-danger">
                    {this.state.error}
                  </div>
                </div>
            </form>
        </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(withNavigate(AlertsPlusTemplateForm))
